import { OpenAppParams } from 'app/shared/types/open-app-params.types';
import qs from 'qs';

const LOCAL_STORAGE_KEY = 'openAppParams';

export const useOpenParams = (): OpenAppParams => {
  const routeParams = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  const params = {
    authToken: routeParams.authToken as string || '',
    apiUrl: routeParams.apiUrl as string || '',
    locale: routeParams.locale as string || 'en',
    buildingUuid: routeParams.buildingUuid as string || '',
    appBrand: routeParams.appBrand as string || '',
  };
  const storedParams = localStorage.getItem(LOCAL_STORAGE_KEY);
  const currentStorage = storedParams ? JSON.parse(storedParams) : params;

  if (routeParams.authToken && routeParams.apiUrl && routeParams.appBrand && routeParams.buildingUuid && routeParams.locale) {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(params));

    return params;
  }

  return currentStorage;
};

// Persist a refreshed token so a hard reload (which re-reads localStorage) uses it.
export const updateStoredAuthToken = (authToken: string): void => {
  try {
    const storedParams = localStorage.getItem(LOCAL_STORAGE_KEY);

    if (!storedParams) {
      return;
    }

    const parsed = JSON.parse(storedParams);
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify({ ...parsed, authToken }));
  } catch {
    // Storage unavailable/malformed — in-memory token state is the source of truth.
  }
};
